<!-- Platform segmented control -->
<div class="inline-flex items-center rounded-lg bg-gray-200/70 p-0.5" role="radiogroup" aria-label="Platform">
  @for (option of platforms; track option.value) {
    @let active = filters().platform === option.value;
    <button
      type="button"
      role="radio"
      [attr.aria-checked]="active"
      (click)="selectPlatform(option.value)"
      class="flex items-center gap-1.5 rounded-md px-3 py-1 text-sm transition-all"
      [class]="active ? 'bg-white shadow-sm font-medium text-gray-900' : 'text-gray-600 hover:text-gray-900'"
    >
      @if (option.icon) {
        <img [src]="option.icon" alt="" class="w-3.5 h-3.5" />
      }
      {{ option.label }}
    </button>
  }
</div>

<!-- Location dropdown -->
<app-location-select
  [locations]="locations()"
  [value]="filters().locationId"
  (valueChange)="selectLocation($event)"
  (opened)="close()"
/>

<!-- Size dropdown -->
<app-size-select
  [sizes]="sizes()"
  [value]="filters().sizeKey"
  (valueChange)="selectSize($event)"
  (opened)="close()"
/>

<!-- Date range picker -->
<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen()"
    class="flex items-center gap-2 rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-gray-200 hover:bg-gray-50 transition-colors"
  >
    <app-icon name="calendar" class="w-4 h-4 text-[#0A84FF]" />
    {{ buttonLabel() }}
    <app-icon name="chevron" class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="isOpen()" />
  </button>

  @if (isOpen()) {
    <div class="absolute right-0 z-30 mt-2 flex flex-col sm:flex-row rounded-2xl bg-white shadow-xl ring-1 ring-gray-200 overflow-hidden">
      <ul class="flex sm:flex-col gap-0.5 overflow-x-auto p-2 sm:w-44 border-b sm:border-b-0 sm:border-r border-gray-100">
        @for (preset of presets; track preset.key) {
          <li>
            <button
              type="button"
              (click)="selectPreset(preset.key)"
              class="w-full whitespace-nowrap rounded-lg px-3 py-1.5 text-left text-sm transition-colors"
              [class]="filters().preset === preset.key ? 'bg-[#0A84FF] text-white font-medium' : 'text-gray-700 hover:bg-gray-100'"
            >
              {{ preset.label }}
            </button>
          </li>
        }
      </ul>

      <div class="p-4">
        <app-date-range-calendar [(from)]="draftFrom" [(to)]="draftTo" [min]="minDate" [max]="today" />

        <p class="mt-3 text-xs text-gray-500">{{ draftLabel() }}</p>
        <p class="text-xs text-gray-400">Up to 1 year of history</p>

        <div class="mt-3 flex justify-end gap-2">
          <button
            type="button"
            (click)="close()"
            class="rounded-lg px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="apply()"
            [disabled]="!draftFrom() || !draftTo()"
            class="rounded-lg bg-[#0A84FF] px-3 py-1.5 text-sm font-medium text-white hover:bg-[#0060DF] disabled:opacity-40 transition-colors"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  }
</div>
